var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v(" Hi! Welcome to Btrack. Please login or create an account and link your tracker")])}
var staticRenderFns = []

export { render, staticRenderFns }